export default theme => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
});
